module.exports = __webpack_public_path__ + "static/media/zoomMin.ea2f80d0.svg";